import React                 from 'react'
import { SystemStyleObject } from '@chakra-ui/react';
import { Text }              from '@chakra-ui/react';

const PageTitle = (props: React.PropsWithChildren) => {
	const { children } = props;
  return (
	<Text
		className='poppins-semibold'
		{...styles.container.base}
		lg={styles.container.lg}
		marginRight="20px"
	>
		{children}
	</Text>
  )
}

export default PageTitle

const styles: {
	[key: string]: {
		[key: string]: SystemStyleObject
	}
} = {
	container: {
		base: {
			fontSize: "22px",
		},
		lg: {
			fontSize: "22px",
		}
	},
};